import { produce } from 'immer'
import type { State } from '../typings'

export type LoadDataAction = { type: 'loadData' }

export const loadDataAction = (state: State) =>
  produce(state, (draft) => {
    draft.page = 0
    draft.loading = true
    draft.response = undefined
  })

export const loadDataActionCreator = (): LoadDataAction => ({
  type: 'loadData',
})
